import React, { createContext, useContext, useState, useMemo, useCallback, ReactNode } from 'react';

interface PageTitleContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  titleExtra: ReactNode;
  setTitleExtra: (extra: ReactNode) => void;
}

const PageTitleContext = createContext<PageTitleContextType>({
  pageTitle: '',
  setPageTitle: () => {},
  titleExtra: null,
  setTitleExtra: () => {},
});

export const usePageTitleContext = () => useContext(PageTitleContext);

export const PageTitleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [titleExtra, setTitleExtra] = useState<ReactNode>(null);

  const stableSetPageTitle = useCallback((title: string) => setPageTitle(title), []);
  const stableSetTitleExtra = useCallback((extra: ReactNode) => setTitleExtra(extra), []);

  const value = useMemo(() => ({
    pageTitle,
    setPageTitle: stableSetPageTitle,
    titleExtra,
    setTitleExtra: stableSetTitleExtra,
  }), [pageTitle, titleExtra, stableSetPageTitle, stableSetTitleExtra]);

  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
};
